import { render, staticRenderFns } from "./DashboardLanguageItem.vue?vue&type=template&id=1355ceda&scoped=true&"
import script from "./DashboardLanguageItem.vue?vue&type=script&lang=js&"
export * from "./DashboardLanguageItem.vue?vue&type=script&lang=js&"
import style0 from "./DashboardLanguageItem.vue?vue&type=style&index=0&id=1355ceda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355ceda",
  null
  
)

export default component.exports